export const apiKey = window.kpa.gmaps_api_key
export const ajaxUrl = window.kpa.ajax_url
export const mapId = 'b05d58b03c502e88'
export const debug = true
